export class TableControl {
  length: number;
  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[];
  sortField: string;
  sortDirection: string;
  filterField: string;
  filterValue: string;

  constructor(length: number, pageSize: number, pageNumber: number, pageSizeOptions: number[], sortField: string, sortDirection: string, filterField: string, filterValue: string) {
    this.length = length;
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.pageSizeOptions = pageSizeOptions;
    this.sortField = sortField;
    this.sortDirection = sortDirection;
    this.filterField = filterField;
    this.filterValue = filterValue;
  }
}
